import { useEffect } from "react";
import { toast } from "sonner";
import {
  Bell,
  CheckCircle,
  XCircle,
  AlertCircle,
  MessageSquare,
} from "lucide-react";
import { useWebSocket } from "@/contexts/WebSocketContext";
import { useLocation } from "wouter";

/**
 * Component ສຳລັບສະແດງການແຈ້ງເຕືອນແບບ Real-time
 */
export function NotificationToast() {
  const { notifications, markAsRead } = useWebSocket();
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (notifications.length === 0) return;

    // ສະແດງການແຈ້ງເຕືອນລ່າສຸດ
    const latestNotification = notifications[0];
    showNotification(latestNotification);
  }, [notifications]);

  const showNotification = (notification: any) => {
    const icon = getNotificationIcon(notification.type);

    toast(notification.title, {
      description: notification.message,
      icon,
      action: notification.link
        ? {
            label: "ເບິ່ງລາຍລະອຽດ",
            onClick: () => {
              markAsRead(notification.id);
              setLocation(notification.link);
            },
          }
        : undefined,
      duration: 5000,
      onDismiss: () => {
        markAsRead(notification.id);
      },
    });
  };

  const getNotificationIcon = (type: string) => {
    switch (type) {
      case "loan:assigned":
      case "assignment":
        return <Bell className="h-5 w-5 text-blue-500" />;
      case "loan:approved":
      case "approval":
        return <CheckCircle className="h-5 w-5 text-green-500" />;
      case "loan:rejected":
      case "rejection":
        return <XCircle className="h-5 w-5 text-red-500" />;
      case "loan:status_changed":
      case "status_change":
        return <AlertCircle className="h-5 w-5 text-yellow-500" />;
      case "loan:commented":
      case "comment":
        return <MessageSquare className="h-5 w-5 text-purple-500" />;
      default:
        return <Bell className="h-5 w-5 text-gray-500" />;
    }
  };

  // Component ນີ້ບໍ່ສະແດງ UI ໂດຍກົງ, ມັນພຽງແຕ່ຈັດການ toast notifications
  return null;
}
